export default {
    cache: {},
    authentication: {
        token: '',
    },

    has(key) {
        if (this.cache[key] === undefined || this.cache[key] === null || this.cache[key] === '') {
            return false;
        } else {
            return true;
        }
    },

    missing(key) {
        return !this.has(key);
    },

    fetch(key) {
        return this.cache[key];
    },

    store(key, value) {
        this.cache[key] = value;
    },

    destroy(key) {
        this.cache[key] = null;
    },

    reset() {
        this.cache = {};
    },
};
